import { Component, Prop, h } from '@stencil/core';

import { DynamicEntryInstallationMode } from '../../../utils/utils.dynamic-entry';
import { DynamicEntryWorkflow } from '../../../utils/utils.landing';
import KbbicoLogo from '../../ui-common/svg/kbbico-logo/kbbico-logo';

@Component({
  tag: 'landing-digital-retail',
  styleUrl: 'landing-digital-retail.css',
  shadow: true,
})
export class LandingDigitalRetail {
  @Prop() dynamicEntryWorkflow: DynamicEntryWorkflow = DynamicEntryWorkflow.DigitalRetail;
  @Prop() offerCode: string = '';
  @Prop() dealerId: string = '';
  @Prop() installationMode?: DynamicEntryInstallationMode = DynamicEntryInstallationMode.Redirect;
  @Prop() legalContent = '';
  @Prop() vehicle: string;
  @Prop() tabList: string[] = ['vin', 'plate', 'ymm'];
  @Prop() inputVin: string = '';
  @Prop() mileage?: number;
  @Prop() theme?: string = '';
  @Prop() dealerGroupId: string = '';
  @Prop() cobrandingGroupId: string = '';

  render() {
    return (
      <div class={`${this.theme}-theme`}>
        <div class="flex flex-col items-center mx-4 lg:mx-0">
          <div class="w-48 mt-14 landing-digital-retail-logo-background landing-digital-retail-logo-background--visibility">
            <KbbicoLogo />
          </div>

          <div class="mt-8 w-full max-w-lg">
            <ico-dynamic-entry-hydrator
              offerCode={this.offerCode}
              dealerId={this.dealerId}
              dynamicEntryWorkflow={this.dynamicEntryWorkflow}
              enableMakeModel={true}
              installationMode={this.installationMode}
              vehicle={this.vehicle}
              tabList={this.tabList}
              inputVin={this.inputVin}
              mileage={this.mileage}
              dealerGroupId={this.dealerGroupId}
              cobrandingGroupId={this.cobrandingGroupId}>
              <ico-dynamic-entry />
            </ico-dynamic-entry-hydrator>
          </div>
          <div class="mt-6 md:mt-12 lg:my-20 mb-12 max-w-6xl">
            <landing-legal testId="ci-legal-text" content={this.legalContent}></landing-legal>
          </div>
        </div>
      </div>
    );
  }
}
